import styled from 'styled-components';

export const QualityLabel = styled.div`
  color: #999;
  margin-bottom: 0;
  display: flex;
  align-items: center;
  gap: 4px;
`;
